import { FlashMessageService } from "zoox-infra";
import PersonService from "@/service/person-service";
import { validationMixin } from "smck-service";

export default {
  name: "NewPasswordDialog",
  mixins: [validationMixin],
  props: {
    openDialog: {
      type: Boolean
    },
    companyParams: {
      type: Object,
      default: () => {
        return {};
      }
    },
    personProp: {
      type: Object,
      default: () => {
        return {
          name: "",
          documentTypeId: "",
          documentNumber: "",
          password: "",
          mobileCountryCode: "",
          mobileCityCode: "",
          mobilePhoneNumber: "",
          phoneNumber: "",
          email: "",
          companyId: ""
        };
      }
    }
  },
  data() {
    return {
      success: false,
      personService: new PersonService(),
      recoverData: {
        documentTypeId: this.personProp.documentTypeId,
        documentNumber: this.personProp.documentNumber,
        passwordRecoverCode: "",
        password: "",
        confirmPassword: ""
      },
      isIncorrectPassword: false
    };
  },
  methods: {
    close() {
      this.recoverData.passwordRecoverCode = "";
      this.recoverData.password = "";
      this.recoverData.confirmPassword = "";
      this.$emit("closeNewPasswordDialog");
    },
    changePassword() {
      if (this.recoverData.password === this.recoverData.confirmPassword) {
        if (this.$refs.changePasswordForm.validate()) {
          this.personService.recoverPassword(this.recoverData).then(resp => {
            if (resp) {
              FlashMessageService.success(
                this.$t("RECOVER_PASSWORD.MESSAGE_CONFIRMATION")
              );
              this.close();
            }
          });
        }
      } else {
        this.isIncorrectPassword = true;
      }
    },
    clearPasswordMessage() {
      if (this.recoverData.confirmPassword.length == 0) {
        this.isIncorrectPassword = false;
      }
    }
  }
};
